
// components/EmailView.js
//import React from 'react';
import React, { useState } from 'react';
import "../ComposeEmail/ComposeEmail.css";
import "./EmailView.css";

// Email view, i.e one selected email

function EmailView({ email, onClose ,onSend}) {

    // handle attachment download
    const handleDownload = (attachment) => {
        // get via api/download-attachment and its id
        //const downloadUrl = `http://localhost:8080/api/download-attachment/${attachment.id}`;
		const downloadUrl = `http://mail.l6.duckdns.org:8781/api/download-attachment/${attachment.id}`;
		
		

        // create a temporary anchor element
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = attachment.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // render HTML content
    const renderEmailBody = () => {
        return (
            <div
                className="email-html-content"
                dangerouslySetInnerHTML={{ __html: email.body }}
            />
        );
    };
	
	
	
	
	
	
	const [to, setTo] = useState(email.from);
    const [subject, setSubject] = useState('Re:'+email.subject);
    const [body, setBody] = useState(email.body);
    const [attachments, setAttachments] = useState([]);

    const [showSent, setShowSent] = useState(false); // State for sent message

    const handleSubmit = (e) => {
        e.preventDefault();
        onSend({
            to,
            subject,
            body,
            attachments
        });
        // Show "Sent!" confirmation
        setShowSent(true);
        setTimeout(() => setShowSent(false), 4000); // Hide after 2 sec
    };

    const handleFileChange = (e) => {
        setAttachments([...attachments, ...e.target.files]);
    };

    const removeAttachment = (index) => {
        const newAttachments = [...attachments];
        newAttachments.splice(index, 1);
        setAttachments(newAttachments);
    };
	
	
	
	
	

    return (
	<div className="email-wrap">
        <div className="email-view">
            <div className="email-view-header">
                <h3>{email.subject}</h3>
                <button className="close-btn" onClick={onClose}>×</button>
            </div>
            <div className="email-view-meta">
                <div className="email-view-sender">
                    <strong>From:</strong> {email.from}
                </div>
                <div className="email-view-date">
                    <span>{email.date}</span>
                </div>
            </div>
            <div className="email-view-body">
                {renderEmailBody()}
            </div>
            {email.attachments && email.attachments.length > 0 && (
                <div className="email-view-attachments">
                    <h4>Attachments:</h4>
                    <div className="attachment-list">
                        {email.attachments.map((attachment, index) => (
                            <div key={index} className="attachment-item">
                                <span>{attachment.name}</span>
                                <button
                                    className="download-btn"
                                    onClick={() => handleDownload(attachment)}
                                >
                                    Download
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
		
		
		<div className="compose-overlay2">
            <div className="compose-container2">
                <div className="compose-header">
                    <h3>Reply</h3>
                    <button className="close-button" onClick={onClose}>×</button>
                </div>
				{!showSent &&
                <form onSubmit={handleSubmit}>
                    <div className="compose-field">
                        <label>To:</label>
                        <input
                            type="text"
                            value={to}
                            onChange={(e) => setTo(e.target.value)}
                            required
                        />
                    </div>
                    <div className="compose-field">
                        <label>Subject:</label>
                        <input
                            type="text"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                        />
                    </div>
                    <div className="compose-body">
                        <textarea
                            value={body}
                            onChange={(e) => setBody(e.target.value)}
                            required
                        />
                    </div>

                    <div className="compose-attachments">
                        {attachments.length > 0 && (
                            <div className="attachment-list">
                                <h4>Attachments:</h4>
                                <ul>
                                    {attachments.map((file, index) => (
                                        <li key={index}>
                                            {file.name} ({(file.size / 1024).toFixed(2)} KB)
                                            <button
                                                type="button"
                                                onClick={() => removeAttachment(index)}
                                                className="remove-attachment"
                                            >
                                                ×
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        <div className="file-upload">
                            <label htmlFor="file-input" className="file-label">
                                Attach Files
                            </label>
                            <input
                                id="file-input"
                                type="file"
                                multiple
                                onChange={handleFileChange}
                                className="file-input"
                            />
                        </div>
                    </div>

                    <div className="compose-actions">
                        <button type="submit" className="send-button">Send</button>
                    </div>
                </form>
				}
                {showSent && <div className="sent-confirmation">Sent!</div>}
            </div>
        </div>
		
	</div>	
    );
}

export default EmailView;